/* Revenue module → IS line resolver (Phase 5).

   Each row in `revenue_module_mappings` answers "which IS line does
   module {type,instance} feed for this company?". Engines that inject
   module outputs into the IS (AE Quota, Company Quota, etc.) consult
   this resolver instead of hardcoding Semitek's rev_ae_quota /
   rev_company_quota ids.

   When a module is not wired for a company (no row), the resolver
   returns null and callers skip injection — the correct behavior for
   a tenant that doesn't use that module. */

export function getModuleTargetLine(mappings, moduleType, moduleInstance = 1) {
  if (!mappings || !mappings.length) return null;
  const match = mappings.find(m =>
    m.module_type === moduleType &&
    (m.module_instance || 1) === moduleInstance
  );
  return match ? match.gl_line_key : null;
}

export function moduleIsWired(mappings, moduleType) {
  if (!mappings || !mappings.length) return false;
  return mappings.some(m => m.module_type === moduleType);
}
